import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { Button, ConfirmDialog, NavLink } from 'components';
import { useMediaQuery } from 'react-responsive';
import useAuthentication from 'utils/useAuthentication';
import { useSelector } from 'react-redux';
import { Routes } from 'utils/routes';
import getConfig from 'next/config';
import { useProducts } from 'utils/products';

const Nav = ({ toggleNavigation, ...rest }) => {
    const { publicRuntimeConfig } = getConfig();
    const router = useRouter();
    const { authenticated, login } = useAuthentication();
    const emailVerified = useSelector((state) => state.user.emailVerified);
    const [showLogoutDialog, setShowLogoutDialog] = useState(false);
    const products = useProducts();
    const isProtected = router.pathname.startsWith(Routes.MyPenly.BaseUrl);

    const goToMitPenly = () => router.push(Routes.MyPenly.Dashboard);
    const buttonSize = useMediaQuery({ query: '(max-width: 1200px)' }) ? 'small' : 'medium';

    return (
        <>
            <nav role="navigation" { ...rest }>
                <ul onClick={ toggleNavigation }>
                    { (!authenticated || !isProtected) && (
                        <>
                            <li>
                                <NavLink href={ Routes.PensionCheck.LandingPage }>Pension</NavLink>
                            </li>
                            {
                                publicRuntimeConfig.featureInvestAdvisory &&
                                <li>
                                    <NavLink href={ Routes.InvestCheck.LandingPage }>Investering</NavLink>
                                </li>
                            }
                            <li>
                                <NavLink href={ Routes.Jura.LandingPage }>Jura</NavLink>
                            </li>
                            {
                                publicRuntimeConfig.featureMortgageAdvisory &&
                                <li>
                                    <NavLink href={ Routes.Advisory.Mortgage.Flow }>Realkredit</NavLink>
                                </li>
                            }

                            { !publicRuntimeConfig.mortgageCheckDeactivated && (
                                <li>
                                    <NavLink href={ Routes.MortgageCheck.LandingPage }>Realkredit</NavLink>
                                </li>
                            ) }
                            { /* <li>
                                <NavLink href={ Routes.PenlyPlay.LandingPage }>Penly Play</NavLink>
                            </li> */ }

                            { /* { publicRuntimeConfig.mortgageCheckDeactivated && (
                                <li>
                                    <NavLink href={ Routes.Services }>Værktøjer</NavLink>
                                </li>
                            ) } */ }

                            <li>
                                <NavLink href={ Routes.Prices }>Priser</NavLink>
                            </li>
                            { /*
                            { !publicRuntimeConfig.faqSectionDeactivated &&
                            <li>
                                <NavLink href={ Routes.FAQ }>FAQ</NavLink>
                            </li>
                            }
                            */ }
                            <li>
                                <NavLink href={ Routes.Articles.LandingPage }>Artikler</NavLink>
                            </li>
                            <li>
                                <NavLink href={ Routes.AboutPenly }>Om os</NavLink>
                            </li>
                            {
                                authenticated  ?
                                    <li style={{ width:60 }}></li>:
                                    <li style={{ marginRight:16 }}>
                                        <Button size={ buttonSize } href={ Routes.CreateProfile() } style={{ whiteSpace: 'nowrap' }}>
                                            Opret gratis profil
                                        </Button>
                                    </li>
                            }
                            <li>
                                { authenticated ? (
                                    <Button size={ buttonSize } style={{ whiteSpace: 'nowrap' }} onClick={ () => goToMitPenly() }>
                                        Mit Penly
                                    </Button>
                                ) : (
                                    <Button size={ buttonSize } style={{ whiteSpace: 'nowrap' }} onClick={ login }>
                                        Log ind
                                    </Button>
                                ) }
                            </li>
                        </>
                    ) }

                    { authenticated && isProtected && (
                        <>
                            <li>
                                <NavLink href={ Routes.MyPenly.Pension.Dashboard }>Pension</NavLink>
                            </li>
                            { !publicRuntimeConfig.mortgageCheckDeactivated && (
                                <li>
                                    <NavLink href={ Routes.MyPenly.Mortgage.Dashboard }>Realkredit</NavLink>
                                </li>
                            ) }
                            <li>
                                <NavLink href={ Routes.MyPenly.Advisory.BookAdvisor('') } onClick={ (e) => e.target.blur() }>
                                    Rådgivning
                                </NavLink>
                                <ul>
                                    <li>
                                        <NavLink href={ Routes.Advisory.Nedsparing.Flow } onClick={ (e) => e.target.blur() }>
                                            Book nedsparingsrådgivning
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink href={ Routes.InvestCheck.LandingPage } onClick={ (e) => e.target.blur() }>
                                            Book investeringsrådgivning
                                        </NavLink>
                                    </li>
                                    { products && products['economy-advisory-full'] &&
                                    <li>
                                        <NavLink href={ publicRuntimeConfig.featurePensionCheckNewOrderFlow? Routes.Advisory.EconomyCheck.Flow : Routes.MyPenly.Advisory.Product.Flow(products['economy-advisory-full']) } onClick={ (e) => e.target.blur() }>
                                            Book ØkonomiTjek
                                        </NavLink>
                                    </li>
                                    }

                                    { products && products['pension-advisory-hourlyrate'] &&
                                    <li>
                                        <NavLink href={  publicRuntimeConfig.featurePensionCheckNewOrderFlow? Routes.Advisory.PensionAdvice.Flow : Routes.MyPenly.Advisory.Product.Flow(products['pension-advisory-hourlyrate']) } onClick={ (e) => e.target.blur() }>
                                            Book en times pensionsrådgivning
                                        </NavLink>
                                    </li>
                                    }
                                    <li>
                                        <NavLink href={ Routes.Jura.LandingPage } onClick={ (e) => e.target.blur() }>
                                            Book juridisk rådgivning
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink href={ Routes.Advisory.PenlySubscription.Flow } onClick={ (e) => e.target.blur() }>
                                            Book Penly Abonnement
                                        </NavLink>
                                    </li>
                                    { publicRuntimeConfig.featureMortgageAdvisory && (
                                        <li>
                                            <NavLink href={ Routes.Advisory.Mortgage.Flow } onClick={ (e) => e.target.blur() }>
                                                Book lånerådgivning
                                            </NavLink>
                                        </li>
                                    ) }

                                    <li>
                                        <NavLink href={ Routes.MyPenly.Orders.BaseUrl } onClick={ (e) => e.target.blur() }>
                                            Dine ordrer
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink href={ Routes.MyPenly.Advisory.Sharings } onClick={ (e) => e.target.blur() }>
                                            Delinger
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink href={ Routes.MyPenly.Advisory.Messages } onClick={ (e) => e.target.blur() }>
                                            Beskeder
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <span notif={ !emailVerified ? '!' : undefined }>Din profil</span>
                                <ul>
                                    <li>
                                        <NavLink href={ Routes.MyPenly.Profile.Settings.Edit } onClick={ (e) => e.target.blur() }>
                                            Indstillinger
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink href={ Routes.MyPenly.Profile.ProfileData.Household } onClick={ (e) => e.target.blur() }>
                                            Profildata
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink href={ Routes.MyPenly.Profile.Documents } onClick={ (e) => e.target.blur() }>
                                            Dokumenter
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink href={ Routes.MyPenly.Profile.Affiliations.Affiliates } onClick={ (e) => e.target.blur() }>
                                            Dine fordele
                                        </NavLink>
                                    </li>
                                </ul>
                                <div></div>
                            </li>
                            <li>
                                <Button size={ buttonSize } onClick={ () => setShowLogoutDialog(true) }>
                                    Log ud
                                </Button>
                                <ConfirmDialog
                                    text={{
                                        title: 'Log ud',
                                        content: 'Er du sikker på at du vil logge ud?',
                                        yes: 'Log ud',
                                        no: 'Nej',
                                    }}
                                    open={ showLogoutDialog }
                                    handleClose={ () => setShowLogoutDialog(false) }
                                    onConfirm={ () => router.push(Routes.Logout) }
                                />
                            </li>
                        </>
                    ) }
                </ul>
            </nav>
        </>
    );
};

Nav.propTypes = {
    toggleNavigation: PropTypes.func.isRequired,
};

export default Nav;
